import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { safeT } from '@/shared/localization';
import { useTranslations } from 'next-intl';
import { useMetadata } from './useMetaData';
type CategoryOption = {
  value: string;
  label: string;
};
type UseProductCategoryReturn = {
  categoryLv0: CategoryOption[];
  categoryLv1: CategoryOption[];
  categoryLv2: CategoryOption[];
  genderOptions: CategoryOption[];
  ageGroupOptions: CategoryOption[];
};
export default function useProductCategory(selectedCategoryLv0, selectedCategoryLv1, options) {
  const $ = _c(41);
  const t = useTranslations("meta");
  const {
    data: t0
  } = useMetadata();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {
      product: {
        categoryMap: []
      },
      detail: {
        genders: [],
        ageGroups: []
      }
    } : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const meta = t1;
  let t2;
  if ($[2] !== meta.product.categoryMap || $[3] !== options || $[4] !== t) {
    let t3;
    if ($[6] !== t) {
      t3 = category => ({
        value: category.categoryLv0,
        label: safeT(t, `category_lv0.${category.categoryLv0}`, category.categoryLv0)
      });
      $[6] = t;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== options) {
      t4 = category_0 => !options?.filterCategoryLv0Values?.(category_0);
      $[8] = options;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t2 = meta.product.categoryMap.map(t3).filter(t4);
    $[2] = meta.product.categoryMap;
    $[3] = options;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const categoryLv0 = t2;
  let t3;
  bb0: {
    if (!selectedCategoryLv0) {
      let t4;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[10] = t4;
      } else {
        t4 = $[10];
      }
      t3 = t4;
      break bb0;
    }
    let t4;
    if ($[11] !== meta.product.categoryMap || $[12] !== selectedCategoryLv0 || $[13] !== t) {
      let t5;
      if ($[15] !== selectedCategoryLv0) {
        t5 = category_1 => category_1.categoryLv0 === selectedCategoryLv0;
        $[15] = selectedCategoryLv0;
        $[16] = t5;
      } else {
        t5 = $[16];
      }
      const selectedCategory = meta.product.categoryMap.find(t5);
      t4 = selectedCategory?.categoriesLv1.map(lv1 => ({
        value: lv1.categoryLv1,
        label: safeT(t, `category_lv1.${lv1.categoryLv1}`, lv1.categoryLv1)
      })) ?? [];
      $[11] = meta.product.categoryMap;
      $[12] = selectedCategoryLv0;
      $[13] = t;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = t4;
  }
  const categoryLv1 = t3;
  let t4;
  bb1: {
    if (!selectedCategoryLv0 || !selectedCategoryLv1) {
      let t5;
      if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[17] = t5;
      } else {
        t5 = $[17];
      }
      t4 = t5;
      break bb1;
    }
    let t5;
    if ($[18] !== meta.product.categoryMap || $[19] !== selectedCategoryLv0 || $[20] !== selectedCategoryLv1 || $[21] !== t) {
      let t6;
      if ($[23] !== selectedCategoryLv0) {
        t6 = category_2 => category_2.categoryLv0 === selectedCategoryLv0;
        $[23] = selectedCategoryLv0;
        $[24] = t6;
      } else {
        t6 = $[24];
      }
      const selectedCategory_0 = meta.product.categoryMap.find(t6);
      const selectedLv1 = selectedCategory_0?.categoriesLv1.find(lv1_0 => lv1_0.categoryLv1 === selectedCategoryLv1);
      t5 = selectedLv1?.categoriesLv2.map(lv2 => ({
        value: lv2,
        label: safeT(t, `category_lv2.${selectedCategoryLv1}.${lv2}`, lv2)
      })) ?? [];
      $[18] = meta.product.categoryMap;
      $[19] = selectedCategoryLv0;
      $[20] = selectedCategoryLv1;
      $[21] = t;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    t4 = t5;
  }
  const categoryLv2 = t4;
  let t5;
  if ($[25] !== meta.detail.genders || $[26] !== t) {
    let t6;
    if ($[28] !== t) {
      t6 = gender => ({
        value: gender,
        label: safeT(t, `gender.${gender}`, gender)
      });
      $[28] = t;
      $[29] = t6;
    } else {
      t6 = $[29];
    }
    t5 = meta.detail.genders.map(t6);
    $[25] = meta.detail.genders;
    $[26] = t;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  const genderOptions = t5;
  let t6;
  if ($[30] !== meta.detail.ageGroups || $[31] !== t) {
    let t7;
    if ($[33] !== t) {
      t7 = ageGroup => ({
        value: ageGroup,
        label: safeT(t, `age_group.${ageGroup}`, ageGroup)
      });
      $[33] = t;
      $[34] = t7;
    } else {
      t7 = $[34];
    }
    t6 = meta.detail.ageGroups.map(t7);
    $[30] = meta.detail.ageGroups;
    $[31] = t;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  const ageGroupOptions = t6;
  let t7;
  if ($[35] !== ageGroupOptions || $[36] !== categoryLv0 || $[37] !== categoryLv1 || $[38] !== categoryLv2 || $[39] !== genderOptions) {
    t7 = {
      categoryLv0,
      categoryLv1,
      categoryLv2,
      genderOptions,
      ageGroupOptions
    };
    $[35] = ageGroupOptions;
    $[36] = categoryLv0;
    $[37] = categoryLv1;
    $[38] = categoryLv2;
    $[39] = genderOptions;
    $[40] = t7;
  } else {
    t7 = $[40];
  }
  return t7;
}